import { Link, useNavigate } from "react-router-dom";
import { ArrowUpRight, Building2, Inbox, ListChecks, LogOut } from "lucide-react";
import { Wordmark } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

export const Navbar = ({ variant = "landing" }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const onLogout = async () => { navigate("/", { replace: true }); await logout(); };

  return (
    <header className="fixed top-0 inset-x-0 z-50 border-b border-white/10 bg-[#0B0F17]/75 backdrop-blur-xl" data-testid="navbar">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 h-16 flex items-center justify-between">
        <Wordmark to={user ? (user.role === "admin" ? "/admin" : "/panel") : "/"} />
        {variant === "landing" && (
          <nav className="hidden md:flex items-center gap-8 font-mono text-xs uppercase tracking-[0.18em] text-[#F5F1E8]/70">
            <a href="#plataforma" data-testid="nav-platform-link" className="hover:text-[#F59E0B] transition-colors">Plataforma</a>
            <a href="#catalogo" data-testid="nav-catalog-link" className="hover:text-[#F59E0B] transition-colors">Catálogo</a>
            <a href="#riesgo" data-testid="nav-risk-link" className="hover:text-[#F59E0B] transition-colors">Score</a>
          </nav>
        )}
        <div className="flex items-center gap-2 sm:gap-3">
          {user ? (
            <>
              {variant === "landing" && (
                <Link to="/panel" data-testid="nav-dashboard-link" className="font-mono text-xs uppercase tracking-[0.16em] px-4 py-2.5 border border-white/15 rounded-full hover:border-[#F59E0B] transition-colors">Mi panel</Link>
              )}
              {user.role === "admin" && (
                <Link to="/admin" data-testid="nav-admin-inbox-link" className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.16em] px-4 py-2.5 border border-[#F59E0B]/50 text-[#F59E0B] rounded-full hover:bg-[#F59E0B] hover:text-[#0B0F17] transition-colors">
                  <Inbox className="w-3.5 h-3.5" /> <span className="hidden sm:inline">Bandeja</span>
                </Link>
              )}
              {user.role !== "admin" && (
                <Link to="/plan-de-accion" data-testid="nav-action-plan-link" aria-label="Plan de acción" className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.16em] p-2.5 sm:px-4 border border-white/15 rounded-full hover:border-[#F59E0B] hover:text-[#F59E0B] transition-colors">
                  <ListChecks className="w-4 h-4" /> <span className="hidden lg:inline">Plan</span>
                </Link>
              )}
              {user.role !== "admin" && (
                <Link to="/perfil" data-testid="nav-profile-link" aria-label="Perfil de empresa" className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.16em] p-2.5 sm:px-4 border border-white/15 rounded-full hover:border-[#F59E0B] hover:text-[#F59E0B] transition-colors">
                  <Building2 className="w-4 h-4" /> <span className="hidden sm:inline">Empresa</span>
                </Link>
              )}
              <span className="hidden sm:block font-mono text-xs text-[#F5F1E8]/60" data-testid="nav-user-name">{user.name}</span>
              <button onClick={onLogout} data-testid="nav-logout-button" aria-label="Cerrar sesión" className="p-2.5 rounded-full border border-white/15 hover:border-rose-400 hover:text-rose-400 transition-colors">
                <LogOut className="w-4 h-4" />
              </button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login-link" className="font-mono text-xs uppercase tracking-[0.16em] px-3 py-2 text-[#F5F1E8]/80 hover:text-white">Entrar</Link>
              <Link to="/registro" data-testid="nav-register-button" className="group inline-flex items-center gap-1.5 font-mono text-xs uppercase tracking-[0.16em] pl-4 pr-3 py-2.5 rounded-full bg-[#F59E0B] text-[#0B0F17] font-medium hover:bg-[#F5F1E8] transition-colors">
                Auditar <ArrowUpRight className="w-3.5 h-3.5 transition-transform group-hover:rotate-45" />
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
};
